import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HashedAssetDirective } from './hashed-asset.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvalidFeedbackComponent } from './invalid-feedback/invalid-feedback.component';
import { NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { LibsModule } from 'ngx-libs';
import { ClipboardModule } from 'ngx-clipboard';
import { RouterModule } from '@angular/router';
// import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { LimitDecimalDirective } from './limit-decimal.directive';
import { PaginationComponent } from './pagination/pagination.component';
import { LetDirective } from './let.directive';
import { MarginRatioComponent } from './margin-ratio/margin-ratio.component';
import { ConnectButtonComponent } from './connect-button/connect-button.component';
import { ColEvenlyComponent } from './col-evenly/col-evenly.component';
import { GeetestComponent } from './geetest/geetest.component';
import { LightweightChartComponent } from './lightweight-chart/lightweight-chart.component';
import { TradesComponent } from './trades/trades.component';
import { PositionsComponent } from './positions/positions.component';
import { FundsComponent } from './funds/funds.component';
import { PoolFundsComponent } from './pool-funds/pool-funds.component';
import { AddressComponent } from './address/address.component';
import { HealthFactorComponent } from './health-factor/health-factor.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { SelectWalletComponent } from './select-wallet/select-wallet.component';
import { PaymasterComponent } from './paymaster/paymaster.component';
import { LoadingComponent } from './loading/loading.component';

const declarations = [
  HashedAssetDirective,
  InvalidFeedbackComponent,
  PaginationComponent,
  LimitDecimalDirective,
  LetDirective,
  MarginRatioComponent,
  ConnectButtonComponent,
  ColEvenlyComponent,
  GeetestComponent,
  LightweightChartComponent,
  TradesComponent,
  PositionsComponent,
  FundsComponent,
  PoolFundsComponent,
  AddressComponent,
  HealthFactorComponent,
  DateRangeComponent,
  SelectWalletComponent,
  PaymasterComponent,
  LoadingComponent
];

const imports = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  // LocalizeRouterModule,
  NgbDropdownModule,
  NgbPaginationModule,
  LibsModule,
  ClipboardModule,
  RouterModule
];

@NgModule({
  declarations: declarations,
  imports,
  exports: [...declarations, ...imports]
})
export class SharedModule { }
